/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0",
    versionName: "local 0.6.0",
    versionChannel: "local",
    buildDate: "2026-09-28T20:25:24.524Z",
    commitHash: "05d3bf20747ec7862e8b781d244515bbecc98bde",
};
